<script setup lang="ts">
import type { ColumnSet, Action } from '../types'
import { cn } from '@/lib/utils'
import { spacingClasses, horizontalJustifyClasses } from '../utils/classes'
import ACColumn from './ACColumn.vue'

const props = defineProps<{
  element: ColumnSet
  onAction?: (action: Action, inputs: Record<string, string>) => void
}>()
</script>

<template>
  <div
    :class="cn(
      'flex gap-4 items-stretch',
      spacingClasses[props.element.spacing ?? 'default'],
      horizontalJustifyClasses[props.element.horizontalAlignment ?? 'left'],
      props.element.height === 'stretch' && 'flex-1'
    )"
  >
    <ACColumn
      v-for="(column, index) in props.element.columns"
      :key="index"
      :element="column"
      :on-action="props.onAction"
    />
  </div>
</template>
